import {
  AgentManualCabinBookingInput,
  AgentManualCabinBookingOutput,
  ITripBooking,
  SaveCruiseCabinsInput,
} from "@cruisen/contract"
import { callFirebaseFunction } from "../callFirebaseFunction.ts"
import { _t } from "@cruisen/i18n"

export const saveCruiseCabins = async (input: SaveCruiseCabinsInput): Promise<void> => {
  const response = await callFirebaseFunction({
    name: "bookingAction",
    payload: {
      action: "saveCruiseCabins",
      ...input,
    },
  })

  if (response.error) {
    alert(`${_t("errors.booking")} ${_t("errors.tryAgainLater")}`)
  }
}

export const agentManualCabinBook = async (
  input: AgentManualCabinBookingInput,
): Promise<ITripBooking> => {
  const response = await callFirebaseFunction({
    name: "bookingAction",
    payload: {
      action: "agentManualCabinBook",
      ...input,
    },
  })

  if (response.error) {
    alert(`${_t("errors.booking")} ${_t("errors.tryAgainLater")}`)
    return null
  }

  return (response.data as AgentManualCabinBookingOutput).result
}
